import React from 'react'

class InvitePhone extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      sent: false
    }
  }

  inviteTextSend = e => {
    e.preventDefault()

    this.setState((state, props) => ({
      sent: true
    }))

    const aid = this.props.aid
    const phoneNumber = this.props.phoneNumber
    const firstName = this.props.firstName
    const lastName = this.props.lastName
    console.log("InvitePhone.inviteTextSend: " +
      "aid=[" + aid + "], " +
      "phone=[" + phoneNumber + "], " +
      "firstName=[" + firstName + "], " +
      "lastName=[" + lastName + "]")

    this.props.sendPhoneInvite(aid, phoneNumber, firstName, lastName)
  }

  render() {
    const { sent } = this.state

    return (
      <span className="invite-phone">
        <span className="invite-name">
          {this.props.firstName} {this.props.lastName}
        </span>
        <span className="invite-phone-number">{this.props.phoneNumber}</span>
        <a
          href="#"
          className="invite-tag"
          onClick={e => {
            this.inviteTextSend(e)
          }}
          disabled={sent}
        >
          Add +
        </a>
      </span>
    )
  }
}

export default InvitePhone



// WEBPACK FOOTER //
// ./src/Components/InvitePhone.js